import styled, { css } from 'styled-components'

import Button from '@components/shared/Button'
import { Typography } from '@components/shared/typography/sc.typography'

export const SaveButton = styled(Button)<{ $disabled?: boolean }>`
  border-radius: 40px;
  width: 100%;

  color: white;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  text-align: center;
  letter-spacing: -0.01em;

  padding: 16px 14px 14px;

  opacity: ${({ $disabled = false }) => ($disabled ? 0.3 : 1)};
`

export const PaymentMethodItem = styled.div<{ $hasBorder?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding-top: 10px;
  padding-bottom: 10px;

  border-top: ${({ $hasBorder = false, theme }) =>
    $hasBorder ? `solid 1px ${theme.palette.common.normalGray}` : '0'};

  cursor: pointer;
`

export const PaymentMethodLeft = styled.div<{ $margin?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  cursor: pointer;

  ${({ $margin = false }) =>
    $margin &&
    css`
      margin-bottom: 40px;
    `}
`

export const PaymentMethodContent = styled.div`
  margin-left: 18px;
`

export const CardName = styled(Typography)`
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;

  color: ${({ theme }) => theme.palette.common.darkestGray};
`

export const CardExpiration = styled(Typography)`
  font-weight: 400;
  font-size: 12px;
  line-height: 25px;

  color: ${({ theme }) => theme.palette.common.normalDarkGray};
`

export const SectionHeader = styled(Typography)<{ $margin?: number }>`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;

  color: ${({ theme }) => theme.palette.common.darkerGray};

  margin-bottom: ${({ $margin = 20 }) => $margin}px;
`

export const PaymentMethodsContainer = styled.div`
  margin-bottom: 30px;
  width: 100%;
`
